const STEPS = [
  { n: "01", icon: "ri-keyboard-box-line", title: "敲一个关键词", desc: "人物名、事件名或任意标签，回车即可。" },
  { n: "02", icon: "ri-filter-3-line", title: "叠加标签筛选", desc: "人物 / 事件 / 时间多维度交叉定位，越筛越准。" },
  { n: "03", icon: "ri-radar-line", title: "按热度挑着读", desc: "热度排序帮你先看最热、最值得吃的瓜点。" },
];

export default function CtaBand() {
  return (
    <section id="guide" className="relative w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="relative overflow-hidden rounded-2xl bg-background-950 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-primary-600/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl" />

          <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500/90 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-compass-3-line" /> 定向找瓜指南
              </span>
              <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-50 md:text-4xl">
                想吃的瓜别大海捞针，<br className="hidden md:block" />
                三步直达黑料目录
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-200/90">
                把关键词检索当成一张寻瓜地图：从热榜找热点，用标签做坐标，按热度挑内容。看料站帮你把搜索变成一条清晰路径。
              </p>
              <a
                href="#search"
                className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 hover:bg-primary-400 transition-colors"
              >
                现在就去检索
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="flex flex-col gap-3">
              {STEPS.map((s, i) => (
                <div
                  key={s.n}
                  className="flex items-start gap-4 rounded-xl border border-foreground-50/10 bg-foreground-950/30 p-4 backdrop-blur"
                >
                  <span
                    className={
                      "flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl " +
                      (i === 1 ? "bg-accent-500 text-foreground-950" : "bg-secondary-700 text-background-50")
                    }
                  >
                    <i className={s.icon} />
                  </span>
                  <div>
                    <p className="font-heading text-sm font-bold text-foreground-50">
                      {s.n} · {s.title}
                    </p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-300">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}